import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-support-modal',
  templateUrl: './support-modal.component.html',
  styleUrls: ['./support-modal.component.scss']
})
export class SupportModalComponent {

  constructor(private dialogRef: MatDialogRef<SupportModalComponent>) {}

  onClose(): void {
    this.dialogRef.close();
  }

}
